import axios from 'axios';
import { API } from './api';

// Track feature usage in localStorage to prevent duplicate tracking
const FEATURE_TRACKING_KEY = 'admin_features_tracked';

export const trackFeatureFirstUse = async (featureName) => {
  try {
    // Check if already tracked in localStorage
    const tracked = localStorage.getItem(FEATURE_TRACKING_KEY);
    const trackedFeatures = tracked ? JSON.parse(tracked) : [];
    
    if (trackedFeatures.includes(featureName)) {
      return; // Already tracked
    }
    
    // Send to backend
    const response = await axios.post(`${API}/admin/track-feature-first-use`, {
      feature_name: featureName
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    
    // If successful and was first use, add to localStorage
    if (response.data.success && response.data.first_use) {
      trackedFeatures.push(featureName);
      localStorage.setItem(FEATURE_TRACKING_KEY, JSON.stringify(trackedFeatures));
    }
  } catch (error) {
    // Silent failure - don't disrupt UX
    console.debug('Feature tracking failed:', error);
  }
};

// Reset on logout
export const resetFeatureTracking = () => {
  localStorage.removeItem(FEATURE_TRACKING_KEY);
};
